import { changeOverlayStatus } from '../../state/actionCreators/index'
import '../../assets/css/Register.css';
import { connect } from 'react-redux';
import { Component } from 'react';

class PasswordReqPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayPopup: false,
        };
    }

    openPopup = () => {
        this.setState((prevState) => {
            return ({
                ...prevState,
                displayPopup: true,
            })
        })
        this.props.changeOverlayStatus('true');
    }

    closePopup = () => {
        this.setState((prevState) => {
            return ({
                displayPopup: false,
            })
        })
        this.props.changeOverlayStatus('false');
    }

    render () {

        let {displayPopup} = this.state;
        return (
            <div className={'mjwi-popup' + (displayPopup ? '' : ' mjwi-hidden')}>
                <div>
                    <h2>Set a Strong Password</h2>
                    <span className="mjwi-popup-close" onClick={this.closePopup}>
                        <i className="fa-solid fa-xmark"></i>
                    </span>
                    <ul class="mjwi-pwd-requirements">
                        <li>At least <strong>8 characters</strong></li>
                        <li>At least <strong>one uppercase letter</strong> (A-Z)</li>
                        <li>At least <strong>one lowercase letter</strong> (a-z)</li>
                        <li>At least <strong>one special character</strong> (e.g., ! @ # $ % ^ & *)</li>
                        <li>At least <strong>one number</strong> (0-9)</li>
                    </ul>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return (
        {
            overlay: state.overlay,
        }
    )
  }
  
  const mapDispatchToProps = (dispatch) => {
    return (
        {
            changeOverlayStatus: (status) => {dispatch(changeOverlayStatus(status))},
        }
    )
  }
  
  export default connect(mapStateToProps,mapDispatchToProps,null, {forwardRef: true} )(PasswordReqPopup);